import { render } from "./earningsIndex.vue?vue&type=template&id=16a941c9&scoped=true"
import script from "./earningsIndex.vue?vue&type=script&lang=js"
export * from "./earningsIndex.vue?vue&type=script&lang=js"

import "./earningsIndex.vue?vue&type=style&index=0&id=16a941c9&lang=scss&scoped=true"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a941c9"]])

export default __exports__